// src/api/notifications.ts
// API-клиент для уведомлений — совместим с dev (module) и prod (types, onlyUnread)
import api from './client';

export interface AppNotification {
  _id: string;
  id?: string;
  module?: string;
  userId?: string;
  type: string;
  action: string;
  entityName: string;
  entityId?: string;
  read: boolean;
  createdAt: string;
  timestamp?: string;
}

export const notificationsApi = {
  // ★ Принимает: module (dev), limit, onlyUnread (prod) / unreadOnly (dev)
  list: (params: { module?: string; types?: string | string[]; limit?: number; onlyUnread?: boolean; unreadOnly?: boolean } = {}) => {
    const query = new URLSearchParams();
    if (params.module) query.set('module', params.module);
    if (params.types) query.set('types', Array.isArray(params.types) ? params.types.join(',') : params.types);
    if (params.limit) query.set('limit', String(params.limit));
    if (params.onlyUnread || params.unreadOnly) query.set('onlyUnread', 'true');
    return api.get(`/notifications?${query.toString()}`).then(r => {
      const d = r.data;
      return (Array.isArray(d) ? d : (d.items || [])) as AppNotification[];
    });
  },

  // ★ Возвращает число (поддерживает оба формата: { unread } и { count })
  count: (params: { module?: string; types?: string | string[] } = {}) => {
    const query = new URLSearchParams();
    if (params.module) query.set('module', params.module);
    if (params.types) query.set('types', Array.isArray(params.types) ? params.types.join(',') : params.types);
    return api.get(`/notifications/count?${query.toString()}`)
      .then(r => r.data?.unread || r.data?.count || 0);
  },

  markRead: (id: string) => api.put(`/notifications/read/${id}`, {}).then(r => r.data),

  // ★ Принимает module (dev)
  markAllRead: (params: { module?: string } = {}) => {
    const query = new URLSearchParams();
    if (params.module) query.set('module', params.module);
    return api.put(`/notifications/read-all?${query.toString()}`, {}).then(r => r.data);
  },
};
